import React, { Component } from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import Story from './components/landing-elements/Story'
import CalcContainer from './components/CalcContainer'
import Home from './components/Home'
import Start from './components/landing-elements/Start'
import Generic404 from './components/Generic404'
import ScrollToTop from './components/ScrollToTop'
import { Helmet } from 'react-helmet'
import Favicon from './favicon.ico'
import './appStyle.css'

export default class App extends Component {
  /**
   * Render the App
   * @returns
   */
  render () {
    return (
      <BrowserRouter>
        <div>
          <Helmet>
            <link rel='shortcut icon' href={Favicon} />
          </Helmet>
          <ScrollToTop>
            <Switch>
              <Route exact path='/' component={Home} />
              <Route path='/story' component={Story} />
              <Route path='/start' component={Start} />
              <Route path='/calculator/:section' component={CalcContainer} />
              <Route path='*' component={Generic404} />
            </Switch>
          </ScrollToTop>
        </div>
      </BrowserRouter>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App.js